import * as s from "../../VideoShareStyled";
import { Text } from "components/atoms/text/Text";
import SmallPopupTemplate from "components/templates/modal/small/SmallPopupTemplate";
import TextArea from "components/atoms/input/TextArea";
import {
  VideoShareUserListResult,
  VideoShareUserUpdate,
} from "api/interfaces/videoshareInterface.interface";
import PrimaryButton from "components/atoms/buttons/PrimaryButton";
import { ButtonWrapper } from "components/templates/modal/ModalTemplateStyled";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import InputDate from "components/atoms/calendar/InputDate";
import { ModalInput } from "components/atoms/input/modal/ModalInput";

type Props = {
  selectedAccount: ProfileAccountInfo;
  state: VideoShareUserListResult;
  newState: VideoShareUserUpdate;
  isExpired: boolean;
  onChangeModal: (type: string, value: boolean) => void;
  onChangeValues: (e: any) => void;
  onChangeDateValue: (date: string) => void;
  onFinish: () => void;
  onClickDelete: () => void;
};

export default function EditVSPresenter({
  selectedAccount,
  state,
  newState,
  onChangeModal,
  onChangeValues,
  onChangeDateValue,
  onFinish,
  isExpired,
  onClickDelete,
}: Props): JSX.Element {
  const buttons = (
    <ButtonWrapper>
      <PrimaryButton
        buttonType="warning"
        label="Delete"
        onClickBtn={onClickDelete}
        data-testid="videoshare-view-edit-primary-button-click-delete"
      />

      <PrimaryButton
        label="Save"
        onClickBtn={onFinish}
        data-testid="videoshare-view-edit-primary-button-finish"
      />
    </ButtonWrapper>
  );

  return (
    <SmallPopupTemplate
      title="Edit Participant"
      subTitle="Edit permissions for a sharing participant, or delete them."
      onClick={onFinish}
      onModal={() => onChangeModal("edit", false)}
      buttons={buttons}
      className="full-width"
      data-testid="videoshare-view-edit-small-popup-template-finish"
    >
      <s.EditTextWrapper>
        <Text className="title">Name</Text>
        <Text className="content">{state.name}</Text>
      </s.EditTextWrapper>
      <s.EditTextWrapper>
        <Text className="title">Email</Text>
        <Text className="content">{state.email}</Text>
      </s.EditTextWrapper>
      <ModalInput label="Message (Optional)">
        <TextArea
          name="message"
          value={newState.message}
          onChange={onChangeValues}
          placeholder="Please enter a message."
          data-testid="videoshare-view-edit-message-change-values"
        />
      </ModalInput>
      <ModalInput
        label={
          <label>
            <input
              type="checkbox"
              name="isExpired"
              checked={isExpired}
              onChange={onChangeValues}
              data-testid="videoshare-view-edit-is-expired-change-values"
            />{" "}
            <Text>Expiration</Text>
          </label>
        }
      >
        <p className="date-select">
          <InputDate
            disabled={!isExpired}
            value={newState.expires}
            endOfDay={true}
            onChange={(date) => onChangeDateValue(date as string)}
            minDate={new Date()}
          />
        </p>
      </ModalInput>
      <ModalInput
        label={
          <label>
            <input
              type="checkbox"
              name="canDownload"
              checked={newState.canDownload}
              onChange={onChangeValues}
              data-testid="videoshare-view-edit-can-download-change-values"
            />{" "}
            <Text>Allow Download</Text>
          </label>
        }
      />
    </SmallPopupTemplate>
  );
}
